import React from 'react';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <div className="footer-content">
      <span>R. Silvio Martins, 145 - Plaza Martin, Botucatu - SP, 18608-870</span>
      <span>CNPJ: 10.736.925/0001-59</span>
      <span className="footer-by">
        By: <a href="https://botusist.com.br" target="_blank" rel="noopener noreferrer">Botusist</a>
      </span>
    </div>
  </footer>
);

export default Footer;
